<template>
  <div class="card">
    <h6>ABOUT YOU</h6>

    <div class="form-group _margin-bottom-20">
      <div class="col-sm-4">
        <form-label id="titleId">Title</form-label>
        <validation-messages label="Title" :$v="$v.titleId">
          <select-list
            id="titleId"
            v-model="personalDetails.titleId"
            value-key="id"
            :list="titleList"
            :error="$v.titleId.$error"
          />
        </validation-messages>
      </div>
    </div>

    <div class="form-group _margin-bottom-20">
      <div class="col-sm-7">
        <form-label id="firstName">First Name</form-label>
        <validation-messages label="First Name" :$v="$v.firstName">
          <form-field
            id="firstName"
            type="alpha-space"
            v-model="personalDetails.firstName"
            maxlength="100"
            :error="$v.firstName.$error"
          />
        </validation-messages>
      </div>
    </div>

    <div class="form-group _margin-bottom-20">
      <div class="col-sm-7">
        <form-label id="lastName">Last Name</form-label>
        <validation-messages label="Last Name" :$v="$v.lastName">
          <form-field
            id="lastName"
            type="alpha-space"
            v-model="personalDetails.lastName"
            maxlength="100"
            :error="$v.lastName.$error"
          />
        </validation-messages>
      </div>
    </div>

    <div class="form-group _margin-bottom-20">
      <div class="col-sm-7">
        <form-label id="dateOfBirth">Date of Birth</form-label>
        <validation-messages label="Date of Birth" :$v="$v.dateOfBirth">
          <date-field
            id="dateOfBirth"
            :dob="true"
            v-model="personalDetails.dateOfBirth"
            :error="$v.dateOfBirth.$error"
            @change="
              personalDetails.dateOfBirth ? $v.dateOfBirth.$touch() : null
            "
          />
          <template v-slot:error>
            <div v-if="$v.dateOfBirth.$error">
              You must be at least 18 year old
            </div>
          </template>
        </validation-messages>
      </div>
    </div>

    <div class="form-group _margin-bottom-20">
      <div class="col-sm-7">
        <form-label id="dayTimePhone">Phone Number</form-label>
        <validation-messages label="Phone Number" :$v="$v.dayTimePhone">
          <form-field
            id="dayTimePhone"
            type="number"
            v-model="personalDetails.dayTimePhone"
            :error="$v.dayTimePhone.$error"
            maxlength="11"
            minlength="10"
            @blur="$v.dayTimePhone.$touch()"
          />
        </validation-messages>
      </div>
    </div>

    <div class="form-group _margin-bottom-20">
      <div class="col-sm-7">
        <form-label id="emailAddress">Email</form-label>
        <validation-messages label="Email" :$v="$v.emailAddress">
          <form-field
            id="emailAddress"
            type="lowercase"
            v-model="personalDetails.emailAddress"
            :error="$v.emailAddress.$error"
            @blur="$v.emailAddress.$touch()"
          />
        </validation-messages>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "CustomerDetails",
  props: {
    $v: Object,
  },
  computed: {
    ...mapState({
      personalDetails: ({ personal_details_customer }) =>
        personal_details_customer,
      employmentStatusList: ({ lookups }) => lookups.employmentStatuses,
      titleList: ({ lookups }) => lookups.titles,
    }),
  },
};
</script>

<style lang="scss"></style>
